import React, { useState, useMemo, useEffect } from 'react';
import { Client, Databases, ID, Query } from 'appwrite';
import styles from '../styles/ContactSection.module.css'; 
import 'react-phone-input-2/lib/style.css';
import 'react-phone-number-input/style.css';
import { parsePhoneNumberFromString, isValidPhoneNumber } from "libphonenumber-js";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-number-input/style.css';
import Popup from './TermOfService';
import Popup2 from './privacyPolicy';
import config from "../config/config";

const ContactSection = () => {
  // Updated Appwrite client configuration to match Demo component
  const client = new Client()
    .setEndpoint(process.env.REACT_APP_ENDPOINT)
    .setProject(process.env.REACT_APP_PROJECT_ID);

  const databases = new Databases(client);

  const [name, setName] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [jobtitle, setJobTitle] = useState(''); 
  const [email, setEmailId] = useState('');
  const [utmParams, setUtmParams] = useState({
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_id: '',
    utm_term: '',
    utm_content: '',
  });
  const [errors, setErrors] = useState({});
  
  // Add success popup state and loading state
  const [isSuccessOpen, setIsSuccessOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Add reset form function
  const resetForm = () => {
    setName('');
    setCompanyName('');
    setPhoneNumber('');
    setJobTitle('');
    setEmailId('');
    setErrors({});
  };

  // Updated phone validation using libphonenumber-js like Demo component
  const handlePhoneNumberChange = (number, country) => {
    setPhoneNumber(number);

    try {
      const fullNumber = number.startsWith("+") ? number : `+${number}`;

      if (isValidPhoneNumber(fullNumber)) {
        const phoneNumberObj = parsePhoneNumberFromString(fullNumber);
        const nationalNumber = phoneNumberObj.nationalNumber;

        const expectedLength = phoneNumberObj.nationalNumber?.length;
        const actualLength = nationalNumber?.length;

        if (actualLength < expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too short - needs ${expectedLength} digits`,
          }));
        } else if (actualLength > expectedLength) {
          setErrors((prev) => ({
            ...prev,
            phoneNumber: `Phone number is too long - should be ${expectedLength} digits`,
          }));
        } else {
          setErrors((prev) => ({ ...prev, phoneNumber: "" }));
        }
      } else {
        setErrors((prev) => ({
          ...prev,
          phoneNumber: "Please enter a valid phone number",
        }));
      }
    } catch (error) {
      console.error("Phone validation error:", error);
      setErrors((prev) => ({
        ...prev,
        phoneNumber: "Please enter a valid phone number",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;
  
    // Validate Name
    if (!name) {
      newErrors.name = "Name is required.";
      isValid = false;
    } else if (!/^[a-zA-Z\s]+$/.test(name)) {
      newErrors.name = "Name can only contain alphabetic characters and spaces.";
      isValid = false;
    }
  
    // Validate Company Name
    if (!companyName) {
      newErrors.companyName = "Company Name is required.";
      isValid = false;
    } else if (!/^[a-zA-Z0-9\s&.,'-]+$/.test(companyName)) {
      newErrors.companyName = "Company Name contains invalid characters.";
      isValid = false;
    }
    if (!jobtitle) {
      newErrors.jobtitle = "Designation is required.";
      isValid = false;
    } else if (!/^[a-zA-Z0-9\s&.,'-]+$/.test(companyName)) {
      newErrors.jobtitle = "Designation contains invalid characters.";
      isValid = false;
    }
    // Validate Phone Number using libphonenumber-js
    if (!phoneNumber) {
      newErrors.phoneNumber = "Mobile Number is required.";
      isValid = false;
    } else {
      const fullNumber = phoneNumber.startsWith("+") ? phoneNumber : `+${phoneNumber}`;
      if (!isValidPhoneNumber(fullNumber)) {
        newErrors.phoneNumber = "Contact Number is invalid.";
        isValid = false;
      }
    }
  
    // Validate Email
    if (!email) {
      newErrors.email = "Email Id is required.";
      isValid = false;
    } else if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      newErrors.email = "Email Id is invalid.";
      isValid = false;
    }
    
    // Set errors and return validation status
    setErrors(newErrors);
    return isValid;
  };
  
  const handleNameChange = (e) => {
    const value = e.target.value;
    
    // Update the name state
    setName(value);
    
    // Validate the name and update the error state accordingly
    if (!/^[a-zA-Z\s]*$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        name: "Name can only contain alphabetic characters and spaces.",
      }));
    } else {
      setErrors((prev) => ({ ...prev, name: "" }));
    }
  };

  const handleCompanyNameChange = (e) => {
    const value = e.target.value;
  
    // Update the company name state
    setCompanyName(value);
  
    // Validate the company name and update the error state accordingly
    if (!/^[a-zA-Z0-9\s&.,'-]*$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        companyName: "Company Name contains invalid characters.",
      }));
    } else {
      setErrors((prev) => ({ ...prev, companyName: "" }));
    }
  };
  const handleJobtitleChange = (e) => {
    const value = e.target.value;
  
    // Update the company name state
    setJobTitle(value);
  
    // Validate the company name and update the error state accordingly
    if (!/^[a-zA-Z0-9\s&.,'-]*$/.test(value)) {
      setErrors((prev) => ({
        ...prev,
        jobtitle: "Designation contains invalid characters.",
      }));
    } else {
      setErrors((prev) => ({ ...prev, jobtitle: "" }));
    }
  };
  // Updated UTM parameter handling to match Demo component
  useEffect(() => {
    const captureUtmParams = () => {
      const params = new URLSearchParams(window.location.search);
      const utmFields = [
        "utm_source",
        "utm_medium",
        "utm_campaign",
        "utm_id",
        "utm_term",
        "utm_content"
      ];

      const newUtmParams = {};
      utmFields.forEach((field) => {
        newUtmParams[field] = params.get(field) || "";
      });
      setUtmParams(newUtmParams);
    };

    captureUtmParams();
    window.addEventListener("popstate", captureUtmParams);

    return () => {
      window.removeEventListener("popstate", captureUtmParams);
    };
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);
  
    if (!validateForm()) {
      setIsLoading(false);
      return;
    }
  
    try {
      // Create form data object similar to Demo component
      const formData = {
        firstname: name, // Map name to firstname to match Demo structure
        businessemail: email, // Use businessemail to match Demo
        companyName,
        phoneNumber,
        jobtitle,
        utmSource: utmParams.utm_source,
        utmMedium: utmParams.utm_medium,
        utmCampaign: utmParams.utm_campaign,
        utmId: utmParams.utm_id,
        utmTerm: utmParams.utm_term,
        utmContent: utmParams.utm_content,
      };
  
      // Submit to both Appwrite and backend like Demo component
      await Promise.all([
        databases.createDocument(
          process.env.REACT_APP_DATABASE_ID,
          config.collectionIds.knowledgenudge,
          ID.unique(),
          formData
        ),
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/submit-popup-form`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        }).then(async (response) => {
          if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || 'Failed to submit form');
          }
        }),
      ]);
  
      // Show success popup and reset form
      setIsSuccessOpen(true);
      resetForm();
      
    } catch (error) {
      console.error('Error creating document:', error);
      setErrors({ submit: "Failed to submit form. Please try again." });
    } finally {
      setIsLoading(false);
    }
  };

  // Add close success modal function
  const closeSuccessModal = () => {
    setIsSuccessOpen(false);
  };

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const handleLinkClick = (e) => {
    e.preventDefault();
    setIsPopupOpen(true);
  };
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  const [isPopup2Open, setIsPopup2Open] = useState(false);
  const handleLinkClick2 = (e) => {
    e.preventDefault();
    setIsPopup2Open(true);
  };
  const handleClosePopup2 = () => {
    setIsPopup2Open(false);
  };

  return (
    <>
      <section className={styles.contactSection}>
        <div className={styles.content}>
          <h1 className={styles.heading}>
            <div className="text-left text-white text-[28px] md:text-4xl 2xl:text-5xl md:mb-6">No platforms to manage.</div>
          </h1>
         <h2 className={styles.heading}>
            <div className="text-white text-left 2xl:text-5xl text-[28px] md:text-4xl">Just smart nudges that keep your people sharp.</div>
          </h2>
        </div>
        
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles['input-container']}>
            <label htmlFor='name' className={styles.placeholder}>
              Name
            </label>
            <input
              type='text'
              id='name'
              className={styles.input}
              value={name}
              onChange={handleNameChange}
            />
            {errors.name && <p className={styles.error}>{errors.name}</p>}
          </div>
          
          <div className={styles['input-container']}>
            <label htmlFor='companyName' className={styles.placeholder}>
              Company Name
            </label>
            <input
              type='text'
              id='companyName'
              className={styles.input}
              value={companyName}
              onChange={handleCompanyNameChange}
            />
            {errors.companyName && <p className={styles.error}>{errors.companyName}</p>}
          </div>
          <div className={styles['input-container']}>
            <label htmlFor='jobtitle' className={styles.placeholder}>
              Designation
            </label>
            <input
              type='text'
              id='jobtitle'
              className={styles.input}
              value={jobtitle}
              onChange={handleJobtitleChange}
            />
            {errors.jobtitle && <p className={styles.error}>{errors.jobtitle}</p>}
          </div>

          <div className={styles['input-container']}>
            <label htmlFor='phoneNumber' className={styles.placeholder}>
              Contact Number
            </label>
            <PhoneInput
              country={"in"}
              value={phoneNumber}
              onChange={(number, country) => handlePhoneNumberChange(number, country)}
              buttonStyle={{ backgroundColor: "rgba(255,255,255,0.2)", }}
              inputStyle={{
                width: "100%",
                borderRadius: "3px",
                fontWeight: "500",
                fontFamily: "inherit",
                backgroundColor: "rgba(255, 255, 255, 0.2)",
              }}
              dropdownStyle={{
                width: "670%",
                height: "450%",
                borderRadius: "5px",
                color: "black",
                textAlign: "left",
                zIndex: 999,
              }}
              enableSearch={true}
              inputProps={{
                required: true,
                autoFocus: false,
              }}
            />
            {errors.phoneNumber && <p className='text-red-500 text-sm'>{errors.phoneNumber}</p>}
          </div>

          <div className={styles['input-container']}>
            <label htmlFor='email' className={styles.placeholder}>
              Email Id
            </label>
            <input
              type='email'
              id='email'
              className={styles.input}
              value={email}
              onChange={(e) => setEmailId(e.target.value)}
            />
            {errors.email && <p className={styles.error}>{errors.email}</p>}
          </div>

          {errors.submit && <p className={styles.error}>{errors.submit}</p>}

          <button
            type="submit"
            className={`${styles.button} bg-white ${
              isLoading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            disabled={isLoading}
          >
            {isLoading ? (
              <div className="flex items-center justify-center space-x-2">
                <svg
                  className="animate-spin h-5 w-5 text-current"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  />
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                  />
                </svg>
                <span>Submitting...</span>
              </div>
            ) : (
              <>
                Book a Demo Now
                <span className={styles.arrow}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    className={`${styles.arrowIcon} `}
                  >
                    <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='4' d='M2 12h20m-7-7 7 7-7 7' />
                  </svg>
                </span>
              </>
            )}
          </button>
        </form>
      </section>

      {/* Success Modal - Same as Demo component */}
      {isSuccessOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="relative bg-white p-8 rounded-lg max-w-md w-full text-center">
            <button
              className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
              onClick={closeSuccessModal}
            >
              <svg
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                ></path>
              </svg>
            </button>
            <h2 className="text-2xl font-bold mb-4">Success!</h2>
            <p className="mb-4">Your demo request has been submitted successfully.</p>
            <button
              className="px-4 py-2 bg-[#C62B6D] text-white rounded"
              onClick={closeSuccessModal}
            >
              Done
            </button>
          </div>
        </div>
      )}


    </>
  );
};

export default ContactSection;